import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../AuthContext';
import ContentEditor from '../components/ContentEditor';
import { firestore, doc, getDoc } from '../firebase-config';
import '../styles/Ministries.css';
import Layout from '../layouts/Layout';

const Ministries = () => {
  const { loggedInUser, underConstruction } = useContext(AuthContext);
  const isAdmin = loggedInUser?.role === 'Admin';
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      try {
        const pageRef = doc(firestore, 'pageContent', 'ministries');
        const pageSnap = await getDoc(pageRef);
        if (pageSnap.exists()) {
          const data = pageSnap.data();
          if (data.sections) {
            setSections(data.sections);
          } else if (data.title || data.content) {
            // Backward compatibility for old data structure
            setSections([{ title: data.title || '', content: data.content || '<p></p>' }]);
          } else {
            setSections([{ title: '', content: '<p></p>' }]);
          }
        } else {
          setSections([{ title: '', content: '<p></p>' }]);
        }
      } catch (error) {
        console.error('Error fetching content:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  const handleSave = (newSections) => {
    setSections(newSections);
  };

  if (underConstruction && !isAdmin) {
    return null; // Layout is rendered by UnderConstruction.js
  }

  if (loading) {
    return (
      <Layout featureType="ministries">
        <div className="loading">
          Loading...
          <div className="skeleton" />
        </div>
      </Layout>
    );
  }

  return (
    <Layout featureType="ministries">
      {isAdmin ? (
        <ContentEditor
          pageId="ministries"
          initialSections={sections}
          onSave={handleSave}
        />
      ) : (
        <div className="sections">
          {sections.map((section, index) => (
            <div key={index} className="section">
              <h2>{section.title || `Section ${index + 1}`}</h2>
              <div dangerouslySetInnerHTML={{ __html: section.content }} />
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
};

export default Ministries;